import React from 'react';
import {
    BrowserRouter,
    Switch,
    Route,
} from "react-router-dom";

import { publicRoutes, privateRoutes } from './routes';
import PrivateRoute from './privateRoute';
import PublicRoute from './publicRoute';
import PageNotFound from '../pages/pageNotFound'
import { NotificationLoader } from '../components'; 

const Router = () => (
    <BrowserRouter>
        <Switch>
            {publicRoutes.map(route => (
                <PublicRoute component={route.component} exact={route.exact} path={route.path} key={route.path} />
            ))}
            {privateRoutes.map(route => (
                <PrivateRoute component={route.component} exact={route.exact} path={route.path} key={route.path} />
            ))}
            <Route component={PageNotFound}/>
        </Switch>
        <NotificationLoader />
    </BrowserRouter>
);

export default Router;